document.addEventListener("alpine:init", () => {
    Alpine.data("postFilterBook", () => ({
        isLoading: false,
        currentFilters: {
            search: "",
        },
        activeFilter: "", // New variable to track only the active term
        postGrid: null,
        filterPrefix: {
            taxonomy: "filter-t-",
            meta: "filter-m-",
            search: "",
        },
        searchValue: null,
        searchForm: null,
        debounceTimer: null,
        showMoreFilters: false,

        tabContainer: null,
        tabOverflow: false,
        tabOverflowStart: true,
        tabOverflowEnd: false,

        init() {
            this.postGrid = this.$el;

            // Get the default filter slug and taxonomy from the data attributes
            const defaultFilterSlug = this.$el.dataset.defaultFilterSlug;
            const defaultFilterTaxonomy =
                this.$el.dataset.defaultFilterTaxonomy;

            if (defaultFilterSlug && defaultFilterTaxonomy) {
                const filterKey = this.getPrefixedFilter(
                    defaultFilterTaxonomy,
                    "taxonomy"
                );
                this.activeFilter = defaultFilterSlug.toLowerCase();
                this.currentFilters[filterKey] = this.activeFilter;
                this.fetchContent();
            }

            this.searchForm = this.$refs.searchContainer;

            if (this.searchForm) {
                this.eventListeners();
            }

            window.addEventListener("toggle-filter", (event) => {
                const { term, filterName, type } = event.detail;
                this.toggleFilters(term, filterName, type);
            });

            // Small screen tab scrolling

            this.tabContainer = this.$el.querySelector(
                ".Post__Filter_Book-filters"
            );

            if (this.tabContainer != null) {
                this.tabContainer.addEventListener("scroll", (event) => {
                    setTimeout(() => {
                        this.checkTabPosition();
                    }, 500);
                });

                pegasus.onResizeFinished(() => {
                    this.checkTabPosition();
                }, true);
            }
        },

        checkTabPosition() {
            this.tabOverflow =
                this.tabContainer.scrollWidth > this.tabContainer.clientWidth;

            this.tabOverflowStart = this.tabContainer.scrollLeft <= 5;
            this.tabOverflowEnd =
                this.tabContainer.scrollLeft >=
                this.tabContainer.scrollWidth -
                    this.tabContainer.clientWidth -
                    5;
        },

        scrollTabsLeft() {
            if (!this.tabOverflowEnd) {
                this.tabContainer.scrollLeft += 150;
            }

            setTimeout(() => {
                this.checkTabPosition();
            }, 500);
        },

        scrollTabsRight() {
            if (!this.tabOverflowStart) {
                this.tabContainer.scrollLeft -= 150;
            }
            setTimeout(() => {
                this.checkTabPosition();
            }, 500);
        },

        eventListeners() {
            this.searchForm.addEventListener("submit", (e) => {
                e.preventDefault();
                if (this.$refs.searchField.value.length) {
                    this.currentFilters.search = this.$refs.searchField.value;
                }

                clearTimeout(this.debounceTimer);

                this.debounceTimer = setTimeout(() => {
                    this.toggleFilters();
                }, 300);
            });
        },

        hasActiveFilters() {
            return Object.keys(this.currentFilters).length > 0;
        },

        toggleFilters(term = "", filterName = "", type = "taxonomy") {
            const filter = this.getPrefixedFilter(filterName, type);

            // Clear all filters of the same type
            for (const key in this.currentFilters) {
                if (key.startsWith(this.filterPrefix[type])) {
                    delete this.currentFilters[key];
                }
            }

            // Set the new filter
            this.currentFilters[filter] = term;

            this.activeFilter = term;
            this.fetchContent();
        },

        removeFilter(filter, value) {
            const filterValue = this.currentFilters[filter];
            const filterValueArray = filterValue.split(",");

            for (let i = 0; i < filterValueArray.length; i++) {
                if (filterValueArray[i] === value) {
                    filterValueArray.splice(i, 1);
                }
            }

            return filterValueArray.toString();
        },

        clearFilters() {
            this.currentFilters = {};
            this.activeFilter = ""; // Reset activeFilter to empty
            window.location.href =
                window.location.protocol +
                "//" +
                window.location.hostname +
                window.location.pathname;
        },

        fetchContent(href = null) {
            let currentUrl = href || this.buildUrl();

            const postGrid = this.postGrid.querySelector(
                "[data-pegasus-filterable]"
            );

            if (!postGrid) {
                console.warn(
                    "Post grid element with data-pegasus-filterable not found."
                );
                this.isLoading = false;
                return;
            }

            console.log("Fetching content for:", currentUrl); // Check the URL and filters
            console.log("Filters applied:", this.currentFilters);

            const elements = [
                'data-pegasus-filterable="' +
                    postGrid.dataset.pegasusFilterable +
                    '"',
            ];

            // Fetch the content without updating the URL
            if (!this.isLoading) {
                this.isLoading = true;

                pegasus.ajaxContent(currentUrl, elements, {}, () => {
                    this.isLoading = false;

                    if (typeof window.modal !== "undefined") {
                        window.modal.init();
                    }
                });
            }
        },

        getCurrentFilters() {
            const url = new URL(window.location.href);
            const params = new URLSearchParams(url.search);

            let currentFilters = {};

            for (const [key, value] of params.entries()) {
                currentFilters[key] = value;
            }

            // Set activeFilter to only the first filter's value if there are any filters
            this.activeFilter = Object.keys(currentFilters).length
                ? Object.values(currentFilters)[0]
                : "";
            return currentFilters;
        },

        filterIsActive(term, filter, type = "taxonomy") {
            const filterName = this.getPrefixedFilter(filter, type);
            if (typeof this.currentFilters[filterName] !== "undefined") {
                return this.currentFilters[filterName].includes(term);
            }
            return false;
        },

        buildUrl() {
            let url =
                window.location.protocol +
                "//" +
                window.location.hostname +
                window.location.pathname +
                "?";
            let i = 1;

            for (const [key, value] of Object.entries(this.currentFilters)) {
                url += `${key}=${value}`;
                if (i < Object.keys(this.currentFilters).length) {
                    url += "&";
                }
                i++;
            }

            return url;
        },

        loadMore() {
            const postGrid = this.$root.querySelector(
                "[data-pegasus-filterable]"
            );
            const dataSelector =
                '[data-pegasus-filterable="' +
                postGrid.dataset.pegasusFilterable +
                '"]';

            const href = this.$el.getAttribute("href");
            const container = [dataSelector];
            const elements = [
                "[data-pegasus-single-card]",
                ".Post__Grid-next-page",
            ];

            if (!this.isLoading) {
                this.isLoading = true;

                pegasus.loadMoreContent(href, container, elements, {}, () => {
                    this.isLoading = false;
                    this.$el.parentElement.remove();
                });
            }
        },

        fetchPage(href = null) {
            const postGrid = this.$root.querySelector(
                "[data-pegasus-filterable]"
            );
            const elements = [
                'data-pegasus-filterable="' +
                    postGrid.dataset.pegasusFilterable +
                    '"',
            ];

            if (!this.isLoading) {
                this.isLoading = true;

                pegasus.ajaxContent(href, elements, {}, () => {
                    this.isLoading = false;

                    if (typeof window.modal !== "undefined") {
                        window.modal.init();
                    }
                });
            }
        },

        getPrefixedFilter(filter, type = "taxonomy") {
            return `${this.filterPrefix[type]}${filter}`;
        },
    }));
});
